var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('h5',{staticClass:"text-muted text-center"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }